export default __webpack_public_path__ + "static/media/captcha.ef9ad5c9.svg";